import { secretQues } from '../services/components/secret_ques.jsx'

function getState(secretQues, quesReceived) {
    return {
        type: "SECRET_QUES",
        secretQues,
        quesReceived
    }
}

export const secretQuesAction = (quesReceived) => dispatch => {
    let state = [];
    let display = quesReceived;
    secretQues((data, msg) => {
        if (msg === "success") {
            state = {
                message: "Success",
                status: 200,
                body: data
            }
        } else {
            state = data
        }
        dispatch(getState(state, display))
    })
}


// WEBPACK FOOTER //
// ./src/actions/secret_ques.jsx